export function senateBounds(i) {
  var bounds = {
    33: [
      -118.67854893805048, 32.75004257029633, -118.05892055848554,
      34.01962796346587,
    ],
    23: [
      -118.89463531894332, 34.20807415561399, -117.23774882302214,
      34.82330152977331,
    ],
    27: [
      -119.02147046261314, 34.11870866289368, -118.34323110950028,
      34.33389061905812,
    ],
    12: [
      -119.93261487490322, 34.78865450296283, -117.6165168579814,
      37.58583701116398,
    ],
    36: [
      -118.14780697321173, 33.33399237349115, -117.57118078506565,
      33.887774472196014,
    ],
    34: [
      -118.05520552793199, 33.69193903404929, -117.83025706454195,
      33.95534325474955,
    ],
    21: [
      -120.73438562729473, 33.163492154732076, -118.6335455063426,
      35.38270564158059,
    ],
    20: [
      -118.61471968011911, 34.14263523031581, -118.18804183943908,
      34.444358248526584,
    ],
    22: [
      -118.08578731539639, 33.92434291267991, -117.52402653654164,
      34.33861445626353,
    ],
    25: [
      -118.30781292320283, 34.02699258080738, -117.43829716755847,
      34.43970327497102,
    ],
    30: [
      -118.17042425108217, 33.865573118843486, -117.76704596748074,
      34.06602909827235,
    ],
    26: [
      -118.3458939827526, 33.98309131909657, -118.12672810125456,
      34.16143811006437,
    ],
    24: [
      -118.95172245436197, 33.67210908776644, -118.29052590940131,
      34.176750108843784,
    ],
    35: [
      -118.44655036095214, 33.65954706646204, -118.17994541469669,
      33.98304329328052,
    ],
    32: [
      -117.84583222637845, 32.80340113230141, -116.08094097739871,
      34.02350797623824,
    ],
    28: [
      -118.45600158674145, 33.93820807005029, -118.23791751484808,
      34.07146496859855,
    ],
  };
  return bounds[i];
}
